import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'importAvailableFilter', pure: false })
export class ImportAvailableColumnsFilterPipe implements PipeTransform {

    transform(selectedFileHeadersList: Array<any>,moduleField: any, selectedFileHeaders: any[]): any {

        const notMapped = selectedFileHeaders
                            .filter(header=> !header.moduleField || (header.moduleField && header.moduleField?.field==moduleField.field))
                            .map(fileHeader=> fileHeader.excelHeader);
        const availableHeader = selectedFileHeadersList.filter(fileHeader=> notMapped.includes(fileHeader.excelHeader))

        return availableHeader;
    }
}
